<template>
  <div class="neibianj">
	<el-row class="mab_20" type="flex" :gutter="20">
      <el-col :span="24">
        <div class="filter-inline-panel cle">
          <el-form :inline="true" size="mini" :model="filterForm" class="filter-panel">
          </el-form>
          <div class="list-opinion fr">
            <el-button type="primary" v-if="hasBtn('btn_add')" size="mini" @click="articleEdit()">新建</el-button>
          </div>
        </div>
       <el-table :data="list" size="mini" border >
      <el-table-column prop="title" align="center" label="问题"></el-table-column>
      <el-table-column prop="content" align="center" label="答案"></el-table-column>
      <el-table-column label="操作" align="center"  fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="articleEdit(scope.row)">编辑</el-button>
          <el-button size="mini" type="info" @click="articleDelete(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
      </el-col>
    </el-row>
    <el-row class="tree-content" type="flex" :gutter="20">
      <el-col :span="24" class="page-pagination">
        <el-pagination style="float:right;" small background :hide-on-single-page="false" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages.page" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="pages.perpage" layout="total, prev, pager, next, sizes, jumper" :total="pages.count" :pagerCount="5"></el-pagination>
      </el-col>
    </el-row>
	<el-dialog title="编辑" width="700px" :visible="editFormVisible" @close="editFormVisible = false">
        <el-form :model="editForm"  size="mini" :rules="editFormRules" ref="editForm">

          <el-form-item label="问题" prop="title">
            <el-input v-model="editForm.title" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="答案" prop="content">
            <el-input v-model="editForm.content" :autosize="{ minRows: 6, maxRows: 6}" type="textarea" auto-complete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="mini" @click.native="editFormVisible = false">取消</el-button>
          <el-button type="primary" size="mini" @click.native="articleAction('editForm')">提交</el-button>
        </div>
      </el-dialog>


  </div>
</template>
<script>
export default {
	name: '',
	data() {
		return {
			editForm:{
				title:'',
				content:'',
				type:'help',
			},
			editFormRules: {
				title: [{
					required: true,
					message: '请输入问题',
					trigger: 'blur'
				}],
				content: [{
					required: true,
					message: '请输入答案',
					trigger: 'blur'
				}],
			},
			editFormVisible:false,
			filterForm:{},
			type: 'help',
			list: [],
			pages: {
				page: 1,
				count: 100,
				perpage: 10,
			},
		};
	},
	// 初始事件
	mounted: function () {
		this.init();
	},
	methods: {
		init() {
			var this_ = this;
			var url = "articleList";
			var datas = {
				page: this_.pages.page,
				num: this_.pages.perpage,
				type: this_.type,
			}
			this_.$post(url, datas).then((res) => {
				this_.list = res.list;
				this_.pages.count = res.sum;
			})
		},
		articleDelete(index, data) {
			var this_ = this;
			var url = "articleDelete";
			var datas = {
				id: data.id
			}
			this_.$confirm('确认删除吗?', '提示', {
				//type: 'warning'
			}).then(() => {
				this_.$post(url, datas).then((res) => {
					this_.$message.success('删除成功');
					this_.init();
				})
			}).catch(() => {});
		},
		articleEdit(e){
			if (e) {
				this.editForm=e;
			}else{
				this.editForm={
					title:'',
					content:'',
					type:'help',
				}
			}
			this.editFormVisible=true;
		},
		// 保存
		articleAction(editForm) {
			var this_ = this;
			this_.$refs[editForm].validate((valid) => {
				if (valid) {
					var url = "articleAction";
					var datas = {
						title: this_.editForm.title,
						content: this_.editForm.content,
						type: this_.editForm.type,
					}
					var tishi = '添加成功';
					if (this_.editForm.id) {
						datas['id'] = this_.editForm.id;
						tishi = '修改成功';
					}
					this_.$post(url, datas).then((res) => {
						this_.$message.success(tishi);
						this_.editFormVisible = false;
						this_.init();
					});
				} else {
					return false;
				}
			})
		},



		// 分页每页显示几条
		handleSizeChange(val) {
			var pages = this.pages;
			pages['perpage'] = val;
			this.pages = pages;
			this.init();
		},
		// 切换分页
		handleCurrentChange(val) {
			var pages = this.pages;
			pages['page'] = val;
			this.pages = pages;
			this.init();
		}
	}
}
</script>
<style scoped>
.neibianj {
	padding: 1px;
}
.filter-inline-panel{
	margin-bottom: 10px;
}
.mab_20{
	margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/system/help.vue